import { Attributes } from '@leverege/ui-attributes';
import { Types } from "../../constants/index.js";
export default {
  name: 'name',
  objectType: Types.deviceGroup,
  valueType: 'string',
  get: (data, cxt) => {
    if (cxt?.getImagineName) {
      const imagineName = Attributes.get('imagineGroupName', Types.deviceGroup, data);
      const devTypeName = Attributes.get('deviceType$name', Types.deviceGroup, data);
      if (imagineName) {
        return `${devTypeName ? `${devTypeName} at ` : ''}${imagineName}`;
      }
    }
    return data?.id;
  },
  displayName: 'Name',
  source: {
    type: Types.apiName,
    editable: false,
    creatable: false
  }
};